import { html, nothing } from 'lit';
import { TfFormControl } from './base';

export class TfTextarea extends TfFormControl {
  static properties = {
    ...TfFormControl.properties,
    rows: { type: Number },
    minlength: { type: Number },
    maxlength: { type: Number },
  };

  constructor() {
    super();
    this.rows = 4;
  }

  _onInput(event) {
    this.value = event.target.value;
    this.dispatchEvent(new Event('input', { bubbles: true, composed: true }));
  }

  _onChange(event) {
    this.value = event.target.value;
    this.dispatchEvent(new Event('change', { bubbles: true, composed: true }));
  }

  render() {
    return html`
      <div class="field">
        ${this._renderLabel()} ${this._renderHelper()}
        <div class="field__control-wrapper">
          <textarea
            class="field__control"
            id=${this._controlId}
            name=${this.name || nothing}
            rows=${this.rows}
            placeholder=${this.placeholder || nothing}
            autocomplete=${this.autocomplete || nothing}
            minlength=${this.minlength ?? nothing}
            maxlength=${this.maxlength ?? nothing}
            ?required=${this.required}
            ?disabled=${this.disabled}
            aria-invalid=${this.invalid ? 'true' : 'false'}
            aria-describedby=${this._describedBy || nothing}
            aria-errormessage=${this.invalid && this.errorText
              ? this._errorId
              : nothing}
            @input=${this._onInput}
            @change=${this._onChange}
            .value=${this.value ?? ''}
          ></textarea>
          ${this._renderErrorIcon()}
        </div>
        ${this._renderError()}
      </div>
    `;
  }
}

customElements.define('tf-textarea', TfTextarea);
